"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = (theme) => ({
    reviewed: {
        color: theme.palette.text.secondary,
        '&.qwinReviewed': {
            color: theme.palette.gray4,
            fontSize: theme.typography.pxToRem(18),
        },
        '&.reviewed': {
            color: theme.palette.text.disabled,
            fontSize: theme.typography.pxToRem(13),
        },
        '&.notReviewed': {
            color: theme.palette.info.main,
            fontSize: theme.typography.pxToRem(13),
        },
    },
    text: {
        color: theme.palette.secondary.dark,
        marginLeft: '24px',
    },
    container: {
        marginTop: '0px',
        background: theme.applyOpacityToHex(theme.palette.text.strong, 0.1),
        display: 'flex',
        alignItems: 'center',
        height: theme.mixins.register.controlBarHeight,
        paddingLeft: theme.mixins.register.paddingLeft,
        paddingRight: theme.mixins.register.paddingRight,
        paddingBottom: 0,
    },
    cancelBtn: {
        marginLeft: 20,
        transform: 'scale(.9)',
    },
});
exports.styles = styles;
